<template>
  <div class="Modal_inner">
    <div class="LogRecord__modal">
      <div
        class="
              LogRecord__modal_fx
              LogRecord__modal_fx--sp_col_reverse
              LogRecord__modal--pt
            "
      >
        <div class="LogRecord__modal_st1_tx">
          <p>
            入力を早く終わらせようとするのではなく、心と体を繊細に、ていねいに感じる時間を過ごしてみてください。
          </p>
        </div>
        <div class="LogRecord__modal_side">
          <div class="LogRecord__range_box">
            <div class="LogRecord__range_head _ft-cl04">
              心の状態
            </div>
            <div class="LogRecord__range">
              <vue-slider
                v-model="sliderHeart"
                v-bind="optionsHeart"
              />
              <div class="LogRecord__range_label LogRecord__range_label_l slider-style-padding">
                不調
              </div>
              <div class="LogRecord__range_label LogRecord__range_label_r slider-style-padding">
                好調
              </div>
            </div>
          </div>
          <div class="LogRecord__range_box">
            <div class="LogRecord__range_head _ft-cl05">
              体の状態
            </div>
            <div class="LogRecord__range">
              <vue-slider
                v-model="sliderhealth"
                v-bind="optionsHealth"
              />
              <div class="LogRecord__range_label LogRecord__range_label_l slider-style-padding">
                不調
              </div>
              <div class="LogRecord__range_label LogRecord__range_label_r slider-style-padding">
                好調
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="LogRecord__modal_btn_area">
      <div
        class="LogRecord__modal_btn ft_en _hover_pt01 _cross"
        @click="nextStep"
      >
        OK
      </div>
    </div>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

export default {
  name: 'LogWriteModalStep1',
  components: { VueSlider },
  props: {
    detailStep1: {
      type: Object,
      default: function() {
        return null
      }
    }
  },
  data() {
    return {
      maxSlider: 10,
      heartRate: 6,
      healthStatus: 6,
      sliderhealth: 6,
      sliderHeart: 6,
      optionsHeart: {
        dotSize: 12,
        max: 10,
        tooltip: 'always',
        fixed: true,
        process: true,
        processStyle: {
          backgroundColor: '#ff0084'
        },
        tooltipStyle: {
          backgroundColor: '#ff0084',
          borderColor: '#ff0084'
        }
      },
      optionsHealth: {
        dotSize: 12,
        max: 10,
        tooltip: 'always',
        fixed: true,
        process: true,
        processStyle: {
          backgroundColor: '#f08441'
        },
        tooltipStyle: {
          backgroundColor: '#f08441',
          borderColor: '#f08441'
        }
      }
    }
  },
  watch: {
    detailStep1: {
      handler() {
        this.setDefault()
      }
    },
    sliderhealth(range) {
      this.healthStatus = range
    },
    sliderHeart(range) {
      this.heartRate = range
    }
  },
  methods: {
    nextStep() {
      this.$emit('changeStep1', 2, this.heartRate, this.healthStatus)
    },
    setDefault() {
      this.sliderhealth = this.detailStep1.health_state
      this.sliderHeart = this.detailStep1.heart_beat_rate
    }
  }
}
</script>
<style>
  .slider-style-padding {
    padding: 6px 0;
  }
</style>
